import(/* webpackMode: "eager", webpackExports: ["AdvertisementBanner"] */ "/app/apps/team-leagues/src/components/molecules/AdvertisementBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CaptainNotificationBanner"] */ "/app/apps/team-leagues/src/components/molecules/CaptainNotificationBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TeamLeagueDetailsHeader"] */ "/app/apps/team-leagues/src/components/molecules/TeamLeagueDetailsHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpectatorPagesFilterWrapper"] */ "/app/apps/team-leagues/src/components/organisms/SpectatorsPagesFilterWrapper.tsx");
